import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import api from "../../utils/Api";

const estadoBadge = {
  pendiente: "tn-badge tn-badge--yellow",
  resuelta:  "tn-badge tn-badge--green",
  rechazada: "tn-badge tn-badge--red",
};

export default function IncidenciasEmpleado() {
  const { token, loading } = useContext(AuthContext);
  const [incidencias, setIncidencias] = useState([]);
  const [generalError, setGeneralError] = useState("");
  const [filterEstado, setFilterEstado] = useState("");

  const loadIncidencias = async () => {
    if (!token) return;
    try {
      const res = await api.get("/incidencias/mias", { headers: { Authorization: `Bearer ${token}` } });
      setIncidencias(res.data);
    } catch {
      setGeneralError("Error al cargar las incidencias.");
    }
  };

  useEffect(() => { loadIncidencias(); }, [token]);

  if (loading) return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: 200, color: "var(--clr-muted)", fontSize: 14 }}>
      Cargando…
    </div>
  );

  const getHoraCorrecta = (comentario) => {
    const match = comentario?.match(/\(Hora correcta:\s*([0-9]{2}:[0-9]{2})\)/);
    return match ? match[1] : null;
  };

  const incidenciasFiltradas = filterEstado
    ? incidencias.filter((i) => i.estado === filterEstado)
    : incidencias;

  return (
    <div>
      <h1 className="tn-page-title">Mis incidencias</h1>
      <p className="tn-page-sub">Historial de incidencias reportadas</p>

      {generalError && <div className="tn-alert tn-alert--danger" style={{ marginBottom: 16 }}>{generalError}</div>}

      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
        <label className="tn-label" style={{ margin: 0 }}>Estado</label>
        <select className="tn-input tn-select" style={{ width: "auto" }} value={filterEstado} onChange={(e) => setFilterEstado(e.target.value)}>
          <option value="">Todos</option>
          <option value="pendiente">Pendiente</option>
          <option value="resuelta">Resuelta</option>
          <option value="rechazada">Rechazada</option>
        </select>
      </div>

      {incidenciasFiltradas.length > 0 ? (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(280px,1fr))", gap: 14 }}>
          {incidenciasFiltradas.map((i) => {
            const horaCorrecta = getHoraCorrecta(i.comentario);
            return (
              <div key={i.id} className="tn-card" style={{ padding: 16 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
                  <span style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: .5, color: "var(--clr-muted)" }}>{i.tipo}</span>
                  <span className={estadoBadge[i.estado] || "tn-badge tn-badge--slate"}>{i.estado}</span>
                </div>
                <p style={{ fontSize: 12.5, color: "var(--clr-muted-lt)", margin: "0 0 8px" }}>
                  {new Date(i.fecha_hora).toLocaleString("es-ES")}
                </p>
                <p style={{ fontSize: 13, color: "var(--clr-muted)", margin: "0 0 6px" }}>{i.comentario}</p>
                {horaCorrecta && (
                  <p style={{ fontSize: 12.5, color: "var(--clr-accent)", margin: 0, fontWeight: 600 }}>
                    Hora correcta: {horaCorrecta}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <div className="tn-card" style={{ padding: "60px 20px", textAlign: "center", color: "var(--clr-muted)", fontSize: 14 }}>
          No tienes incidencias
        </div>
      )}
    </div>
  );
}
